import type { DocMigration } from "../docMigration";

interface ProductLineNameMigrationAttributes {
  productlineName?: string;
  productLineName?: string;
}

const DEFAULT_IDENTIFIER_PREFIX = "identifier_";
const OLD_PARAMETER_ID = "productlineName";
const NEW_PARAMETER_ID = "productLineName";
const PRODUCT_LINE_NAME_TOKEN_REGEX = new RegExp(`\{\{[ ]*${OLD_PARAMETER_ID}[ ]*\}\}`, "g");
const REPLACEMENT_PARAMETER_TOKEN = `{{ ${NEW_PARAMETER_ID} }}`;
const OLD_FORMULA_IDENTIFIER = DEFAULT_IDENTIFIER_PREFIX + OLD_PARAMETER_ID;
const NEW_FORMULA_IDENTIFIER = DEFAULT_IDENTIFIER_PREFIX + NEW_PARAMETER_ID;

const migration: DocMigration = {
  id: "20260902_renameproductlinename",
  description:
    "Rename productlineName to productLineName in condition formulas, annotations, ParameterRef objects, and home attributes",
  apply(json: any): any {
    migrateChildEntityFormulas(json);

    for (const id in json.annotation ?? {}) {
      const annotation = json.annotation[id];
      if (annotation.type === "NOTE" && typeof annotation.text === "string") {
        annotation.text = annotation.text.replace(PRODUCT_LINE_NAME_TOKEN_REGEX, REPLACEMENT_PARAMETER_TOKEN);
      }
    }

    migrateParameterRefs(json);
    migrateHomeAttributes(json);

    return json;
  },
};

export default migration;

function isFormula(value: any): value is { type: "FORMULA"; formula: string } {
  return !!value && typeof value === "object" && value.type === "FORMULA" && typeof value.formula === "string";
}

function isParameterRef(value: any): value is { type: "PARAMETER_REF"; id: string } {
  return !!value && typeof value === "object" && value.type === "PARAMETER_REF" && typeof value.id === "string";
}

function migrateParameterRefs(value: any): void {
  if (!value || typeof value !== "object") {
    return;
  }

  if (Array.isArray(value)) {
    for (const item of value) {
      migrateParameterRefs(item);
    }
    return;
  }

  for (const key in value) {
    const child = value[key];
    if (isParameterRef(child) && child.id === OLD_PARAMETER_ID) {
      child.id = NEW_PARAMETER_ID;
    } else {
      migrateParameterRefs(child);
    }
  }
}

function migrateHomeAttributes(doc: { attributes?: ProductLineNameMigrationAttributes }): void {
  const attributes = doc.attributes;
  if (!attributes || typeof attributes !== "object" || attributes.productlineName === undefined) {
    return;
  }

  if (attributes.productLineName === undefined) {
    attributes.productLineName = attributes.productlineName;
  }
  delete attributes.productlineName;
}

function migrateChildEntityFormulas(doc: any): void {
  for (const docEntityName in doc) {
    for (const entityId in doc[docEntityName]) {
      const tableEntity = doc[docEntityName][entityId];
      if (!tableEntity || typeof tableEntity !== "object" || !("disabled" in tableEntity)) {
        continue;
      }

      if (isFormula(tableEntity.disabled)) {
        tableEntity.disabled = {
          type: "FORMULA",
          formula: tableEntity.disabled.formula.replaceAll(OLD_FORMULA_IDENTIFIER, NEW_FORMULA_IDENTIFIER),
        };
      }
    }
  }
}
